/**
 * DocumentTitle — 라우터 pathless 레이아웃. 경로가 바뀔 때마다 `pageTitles` 선언에 따라
 * `document.title` 을 갱신하고 자식 라우트를 그대로 렌더한다.
 */
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { documentTitleFor } from '@/app/pageTitles';

export default function DocumentTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = documentTitleFor(pathname);
  }, [pathname]);
  return <Outlet />;
}
